import { useEffect, useMemo } from 'react';
import { createPortal } from 'react-dom';
import { ATTRIBUTE_PORTAL_VALUE } from '@carnica/utils';
export var Portal = function Portal(_ref) {
  var children = _ref.children,
    parent = _ref.parent,
    id = _ref.id;
  var notificationElement = useMemo(function () {
    if (id && typeof document !== 'undefined') {
      var element = document.getElementById(id);
      if (element) {
        return element;
      }
    }
    return null;
  }, [id]);
  var el = useMemo(function () {
    return document.createElement('div');
  }, []);
  useEffect(function () {
    var target;
    if (typeof document !== 'undefined') {
      target = parent && parent.appendChild ? parent : document.body;
      if (!notificationElement) {
        el.classList.add('portal-container');
        el.dataset.portal = ATTRIBUTE_PORTAL_VALUE;
        if (id) {
          el.id = id;
        }
        // WORKAROUND: Хак для корректной работы динамического определения слоя для иконки виджета-чата
        el.style.zIndex = '500';
        target.appendChild(el);
      }
    }
    return function () {
      if (typeof document !== 'undefined') {
        target.removeChild(el);
      }
    };
  }, [el, parent, id, notificationElement]);
  return /*#__PURE__*/createPortal(children, notificationElement || el);
};